import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ContactUs from "./pages/ContactUsPage";
import Footer from "./Components/Footer";
import NavBar from "./Components/NavBar";
import './App.css';
import './index.css';
import ProductPage from "./pages/ProductPage";

ReactDOM.render(
    <BrowserRouter>

        <div className="App">
            <NavBar />
            <div id="page-body">
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/contact" element={<ContactUs />} />
                    <Route path="/products" element={<App />} />
                    <Route path="/product/:name" element={<ProductPage />}></Route>
                </Routes>
            </div>
            <Footer className="footer"/>
        </div>
    </BrowserRouter>,

  document.getElementById('root')
);
